import React from 'react';
import './NotionDataTable.css';

const ErrorTable = ({ error, onRetry }) => {
  return (
    <div className="notion-data-container">
      <div className="error">
        <p>❌ {error}</p>
        <button onClick={onRetry} className="retry-button">
          Попробовать снова
        </button>
      </div>
    </div>
  );
};

export default ErrorTable;

